import { THEMES } from "../../data/content";

const HEIGHTS = { sm: 26, md: 34, lg: 64 };

export const Logo = ({ label, size = "md" }) => {
  const theme = label && THEMES.find((t) => t.name === label);
  const h = theme && !theme.logo ? HEIGHTS[size] * 1.45 : HEIGHTS[size];
  const file = !theme ? "enova-wordmark" : theme.logo || `logo-${theme.slug}`;
  return (
    <img
      src={`/brand/${file}.png`}
      alt={theme ? `ENOVA ${theme.name}` : "ENOVA"}
      style={{ height: h, width: "auto" }}
      className="block select-none"
      draggable={false}
    />
  );
};
